export default __webpack_public_path__ + "static/media/img-70.5f60cd77.jpg";